// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1a5CE","title":"ClientCherryInfo_title__3yF3Q","itemText":"ClientCherryInfo_itemText__2-p1T"};